<form
  (keydown.enter)="$event.preventDefault()"
  class="field-container d-block w-100 rounded-pill"
>
  <div class="w-100 d-block">
    <div
      class="d-flex align-items-center justify-between bg-light rounded-3 gap-2 px-2"
    >
      <mat-icon matPrefix class="mon-text-primary">search</mat-icon>
      <mat-form-field
        color="primary"
        class="monek-input flush mb-0 pb-0 flex-fill bg-light"
        appearance="fill"
      >
        <input
          [formControl]="searchControl"
          type="text"
          matInput
          maxlength="30"
          placeholder="{{ inputPlaceholder }}"
          data-test="search-input"
          (keyup)="checkSearchInputValue()"
        />
      </mat-form-field>
      @if (displayClearBtn) {
        <mat-icon
          color="warn"
          class="clear-search-input mon-text-primary flex-shrink-0"
          matSuffix
          data-test="search-clear-btn"
          (click)="clearInput()"
          >close</mat-icon
        >
      }
    </div>
  </div>
</form>
